import React from "react";
import ReactApexChart from "react-apexcharts";

const StackedBarChart = ({ data, width, height }) => {
  try {
    if (!data || !data.series || !Array.isArray(data.series)) {
      throw new Error("Invalid chart data");
    }

    return (
      <React.Fragment>
        <ReactApexChart
          dir="ltr"
          className="apex-charts"
          options={data}
          series={data.series}
          type="bar"
          height={height}
          width={width}
        />
      </React.Fragment>
    );
  } catch (error) {
    console.error("StackedBarChart render error:", error);
    return (
      <div style={{ color: "red", padding: "10px" }}>
       Something went wrong. Use Another favorite prompt to generate
      </div>
    );
  }
};

export default StackedBarChart;
